import { render, staticRenderFns } from "./BaseTableInstallmentBAY.vue?vue&type=template&id=f01bab50&scoped=true&"
import script from "./BaseTableInstallmentBAY.vue?vue&type=script&lang=js&"
export * from "./BaseTableInstallmentBAY.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableInstallmentBAY.vue?vue&type=style&index=0&id=f01bab50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01bab50",
  null
  
)

export default component.exports